import React from 'react'

import { connect } from 'react-redux'
import {getSalesOrg, getSpecialNames} from '../../store/login/reducers'
import { injectIntl } from 'react-intl'
import { capitalizeFirstLetter } from '../../helpers'
import ProductTypes from '../catalog/ProductTypes'

const mapStateToProps = state => {
    return {
        specialNames: getSpecialNames(state, 'specialNames'),
        salesOrg: getSalesOrg(state)
    }
}
const LANG_TO_INDEX = {
    da: 'DA',
    de: 'DE',
    'en-US': 'Z2',
    en: 'EN',
    es: 'ES',
    fi: 'FI',
    'fr-CA': 'FR',
    'en-CA': 'EN',
    fr: 'FR',
    it: 'IT',
    nl: 'NL',
    no: 'NO',
    pt: 'PT',
    pl: 'PL',
    sv: 'SV',
    tr: 'TR',
    he: 'HE',
    ja: 'JA'
}

class ProductDisplayName extends React.Component {
    render() {
        const { product, specialNames, style, intl } = this.props
        const bathroomProductTypes = ProductTypes.BATHROOM.toArray()

        if (!product) {
            return (
                <div className="product-title" data-cy="global__product_display_name" style={style}>
                    <div>-</div>
                </div>
            )
        }

        let locale = LANG_TO_INDEX[intl.locale] || 'Z2'
        let showName = '';
        
        if (specialNames && specialNames[product.productId]) {
            showName = specialNames[product.productId]
        } else if (
            product.translations &&
            product.translations[locale] &&
            product.translations[locale].displayName
        ) {
            showName = product.translations[locale].displayName.toLowerCase()
        } else if (product.displayName) {
            showName = product.displayName.toLowerCase()
        }
 
        showName = showName.replace(/,/g, ', ');

        //Temporal hasta que la descripción no llegue bien del maestro de materiales
        if (locale === 'Z2') {
            showName = showName.replace('woo' , 'w/o overflow')
            showName = showName.replace('lavabo' , 'wba')
            showName = showName.replace('aca ing' , 'mitered')
            showName = showName.replace('faldón' , 'skirt')
            showName = showName.replace('c/recto' , 'strt edge')
        }

        if ((product.colorId === 'TAK' || product.colorId === 'MTR') && this.props.salesOrg != '2012') showName = 'TAJ MAHAL';

        const getProductColorName = () => {
            if (product && product.type && bathroomProductTypes.includes(product.type) && product.colorName) {
                return capitalizeFirstLetter(product.colorName)
            }
            return null
        }

        const productColorName = getProductColorName()
        const showNameFormatted = capitalizeFirstLetter(showName)

        return (
            <div className="product-title" data-cy="global__product_display_name" style={style}>
                <div>
                    {productColorName && productColorName !== showNameFormatted ? (
                        <React.Fragment>
                            <div>{showNameFormatted}</div>
                            <div>{productColorName}</div>
                        </React.Fragment>
                    ) : (
                        <div>
                            {showNameFormatted}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
export default injectIntl(
    connect(
        mapStateToProps,
        null
    )(ProductDisplayName)
)
